import styled from "styled-components";

export const Container = styled.div`
    min-height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    
`